import Cookies from 'cookies-js'
import { UrlStateKey, menu, slovenianLanguageEnabled } from './../constants'
import { setVisitedStatusVisited, getVisitedStatus } from './visitorReducer'
import { testGreenPathServiceConnection } from './pathsReducer'
import { Action } from 'redux'
import * as urlManager from './../utils/urlManager'
import { UiReducer } from '../types'

export enum Lang {
  EN = 'en',
  SL = 'sl',
}

const initialMenuState: UiReducer = {
  lang: Lang.EN,
  info: false,
  odPanelHidden: false,
  pathPanel: false,
  pathPanelContent: null,
}

interface UiAction extends Action {
  lang: Lang
  hidden: boolean
}

const uiReducer = (store: UiReducer = initialMenuState, action: UiAction): UiReducer => {
  switch (action.type) {
    case 'TOGGLE_LANG':
      return { ...store, lang: action.lang }

    case 'SHOW_INFO':
      return { ...store, info: true }

    case 'HIDE_INFO':
      return { ...store, info: false }

    case 'SET_OD_PANEL_HIDDEN':
      return { ...store, odPanelHidden: action.hidden }

    case 'SET_SHORTEST_PATH':
      return { ...store, pathPanel: true, odPanelHidden: false, pathPanelContent: menu.pathList }

    case 'TOGGLE_PATH_PANEL':
      return { ...store, pathPanel: !store.pathPanel }

    case 'SHOW_PATH_LIST':
      return { ...store, pathPanel: true, pathPanelContent: menu.pathList }

    case 'SHOW_LENGTH_FILTER_SELECTOR':
      return { ...store, pathPanel: true, pathPanelContent: menu.lengthLimitSelector }

    default:
      return store
  }
}

export const toggleLanguage = (lang: Lang) => {
  return (dispatch: any) => {
    if (!slovenianLanguageEnabled) {
      dispatch(setLanguage(Lang.EN))
      return
    }
    const toggleToLang = lang === Lang.SL ? Lang.EN : Lang.SL
    dispatch(setLanguage(toggleToLang))
  }
}

export const setLanguage = (lang: Lang) => {
  return (dispatch: any) => {
    const effectiveLang = slovenianLanguageEnabled ? lang : Lang.EN
    Cookies.set('gp-lang', effectiveLang)
    localStorage.setItem('gp-lang', effectiveLang)
    dispatch({ type: 'TOGGLE_LANG', lang: effectiveLang })
  }
}

export const loadSelectedLanguage = () => {
  return (dispatch: any) => {
    if (!slovenianLanguageEnabled) {
      Cookies.set('gp-lang', Lang.EN)
      localStorage.setItem('gp-lang', Lang.EN)
      dispatch({ type: 'TOGGLE_LANG', lang: Lang.EN })
      return
    }
    const langC = Cookies.get('gp-lang')
    const langLs = localStorage.getItem('gp-lang')
    const lang = langC ? (langC as Lang) : (langLs as Lang)
    if (lang && Object.values(Lang).includes(lang)) {
      dispatch({ type: 'TOGGLE_LANG', lang })
    }
  }
}

export const showInfo = () => ({ type: 'SHOW_INFO' })

export const setOdPanelHidden = (hidden: boolean, location: any, history: any) => {
  urlManager.setBoolParam(UrlStateKey.OD_PANEL_VISIBLE, !hidden, location, history)
  return {
    type: 'SET_OD_PANEL_HIDDEN',
    hidden,
  }
}

export const hideInfo = () => {
  return (dispatch: any) => {
    const visited = getVisitedStatus()
    // if first visit, set visited cookie to yes and check connection to qp service
    if (!visited) {
      dispatch(setVisitedStatusVisited())
      dispatch(testGreenPathServiceConnection())
    }
    dispatch({ type: 'HIDE_INFO' })
  }
}

export const showMaxLengthFilterSelector = () => ({ type: 'SHOW_LENGTH_FILTER_SELECTOR' })

export const showPathList = () => ({ type: 'SHOW_PATH_LIST' })

export const togglePathPanel = () => ({ type: 'TOGGLE_PATH_PANEL' })

export default uiReducer
